module.exports = __webpack_public_path__ + "img/network-jl.2767bba1.jpg";